import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import useModalStyles from '../Modals.styles';
import { shareContext } from '../../ShareContext';
import { useWebUserContext } from 'contexts';
import type { WebUserContact } from 'types/User';
import { getUserFullName } from 'utils/webUser';
import useStyles from './ExistingContacts.styles';
import {ContactAvatar} from 'components';

type ExistingContactsPureProps = { contacts: WebUserContact[] };

const ExistingContactsPure = ({
  contacts,
}: ExistingContactsPureProps): JSX.Element => {
  const classes = useStyles();
  const modalClasses = useModalStyles();

  return (
    <>
      <Grid className={modalClasses.text} item xs={12}>
        <FormattedMessage id="share.folder.contacts.edit.already_shared" />
      </Grid>

      <Grid item xs={12}>
        <Grid
          className={classes.existingContacts}
          container
          justifyContent="center"
        >
          {contacts.map(contact => (
            <Grid className={classes.contact} item key={contact.id} xs={3}>
              <ContactAvatar contact={contact} className={classes.avatar} />
              <div className={classes.contactName}>{getUserFullName(contact)}</div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

const ExistingContacts = (): JSX.Element | null => {
  const { selectedFolder } = useContext(shareContext);
  const { webUser } = useWebUserContext();
  const contacts = (selectedFolder?.sharedWith || []).filter(
    (_) => _.id !== webUser.id,
  );

  if (contacts.length === 0) {
    return null;
  }

  return <ExistingContactsPure contacts={contacts} />;
};

export default ExistingContacts;
